export default {
  methods: {
    errorToast(text, append = false) {
      const content = this.$createElement('div', { class: ['d-flex', 'align-items-center'] }, [
        this.$createElement('div', {}, [<font-awesome-icon icon="fa-solid fa-bolt-lightning" class="" />]),
        this.$createElement('div', { class: 'ml-2' }, text)
      ])

      this.$bvToast.toast([content], {
        autoHideDelay: 5000,
        appendToast: append,
        toaster: 'b-toaster-bottom-right',
        toastClass: 'error-toast-body',
        noCloseButton: true,
        bodyClass: 'error-toast'
      })
    }
  }
}
